// DEPRECATED
import { Box, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Filters from './filters'
import DataView from './data-view'

import useGetTaskTypes from '../../hooks/api/useGetTaskTypes'
import useTaskStatusTypes from '../../hooks/api/useTaskStatusTypes'
import { authedAxios } from '../../utils'
import useIsAdmin from '../../hooks/useIsAdmin'
import useIdentities from '../../hooks/api/useIdentities'

const Reports = () => {
  const {
    loading: taskTypesLoading,
    taskTypes,
    hasError: hasTaskTypesError,
  } = useGetTaskTypes()
  const {
    loading: statusTypesLoading,
    taskStatusTypes,
    hasError: hasStatusTypesError,
  } = useTaskStatusTypes()

  const {
    loading: identitiesLoading,
    identities,
    hasError: hasIdentitiesError,
  } = useIdentities()

  const today = new Date()
  const lastWeek = new Date()
  lastWeek.setDate(lastWeek.getDate() - 6)

  const [filters, setFilters] = useState({
    taskTypeIds: [],
    taskStatusTypeIds: [],
    identityIds: [],
    customerIds: [],
    startDate: lastWeek.toLocaleDateString('sv'),
    endDate: today.toLocaleDateString('sv'),
  })

  const { isPriveledged } = useIsAdmin()

  const [data, setData] = useState([])
  const [isLoadingData, setIsLoadingData] = useState(false)
  const [hasDataLoadError, setHasDataLoadError] = useState(false)

  useEffect(() => {
    setFilters({ ...filters, taskTypeIds: taskTypes.map((t) => t.id) })
  }, [taskTypes])

  useEffect(() => {
    if (!taskStatusTypes) return
    const completedStatusType = taskStatusTypes.find(
      (tst) => tst.name === 'Completed'
    )
    if (!completedStatusType) return

    setFilters({ ...filters, taskStatusTypeIds: [completedStatusType.id] })
  }, [taskStatusTypes])

  const getData = () => {
    setIsLoadingData(true)
    setHasDataLoadError(false)
    authedAxios
      .get(
        `/api/report` +
          `?start=${filters.startDate}&end=${filters.endDate}` +
          `&task_status_ids=[${filters.taskStatusTypeIds}]` +
          `&task_type_ids=[${filters.taskTypeIds}]` +
          `&identity_ids=[${filters.identityIds}]` +
          `&customer_ids=[${filters.customerIds}]`
      )
      .then((res) => {
        setIsLoadingData(false)
        const days = {}

        const dayCount =
          1 +
          (new Date(filters.endDate).getTime() -
            new Date(filters.startDate).getTime()) /
            (1000 * 3600 * 24)

        for (let i = 0; i < dayCount; i++) {
          const date = new Date(filters.startDate)
          date.setDate(date.getDate() + i + 1)

          const key = `${date.getMonth() + 1}/${date.getDate()}`

          days[key] = 0
        }

        res.data.report.map((t) => {
          const date = new Date(t.date)
          const key = `${date.getMonth() + 1}/${date.getDate()}`
          if (!days[key]) days[key] = {}
          if (days[key][t.taskTypeId]) return days[key][t.taskTypeId]++
          days[key][t.taskTypeId] = 1
        })

        setData(Object.keys(days).map((date) => ({ date, ...days[date] })))
      })
      .catch((e) => {
        setHasDataLoadError(true)
      })
  }

  useEffect(() => {
    if (!filters.startDate || !filters.endDate) return
    getData()
  }, [filters])

  useEffect(() => {
    if (!identities?.length) return

    if (!isPriveledged)
      setFilters({ ...filters, identityIds: [identities[0].id] })
  }, [identities, isPriveledged])

  return (
    // {/* <Typography variant={'h5'}>Reports</Typography> */}
    // {/* <Typography variant={'h6'} sx={{ mb: 1 }}>
    //   Select data and a timeframe to view
    // </Typography> */}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'stretch',
        flexGrow: 1,
      }}
    >
      <Filters
        filters={filters}
        setFilters={setFilters}
        lists={{ taskTypes, taskStatusTypes, identities }}
        loadingStates={{
          taskTypesLoading,
          statusTypesLoading,
          identitiesLoading,
        }}
        isPriveledged={isPriveledged}
      ></Filters>
      <DataView
        isLoadingData={isLoadingData}
        data={data}
        taskTypes={taskTypes}
        taskStatusTypes={taskStatusTypes}
        filters={filters}
      />
    </Box>
  )
}

export default Reports
